import { useEffect, useState } from "react";
import { getListadoEtiquetas } from "../services/tags";

export function useListadoEtiquetas() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [shouldRefetch, refetch] = useState({});

  useEffect(() => {
    fetchListadoEtiquetas();
  }, [shouldRefetch]);

  async function fetchListadoEtiquetas() {
    setIsLoading(true);
    setIsError(false);
    try {
      const data = await getListadoEtiquetas();
      setData(data);
    } catch (error) {
      setIsError(true);
      setError(error?.message ?? "Error al cargar al listado de etiquetas");
    } finally {
      setIsLoading(false);
    }
  }

  return { data, isLoading, isError, error, refetch };
}
